<div class="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">

  @if (isOpen()) {
    <div class="w-96 h-[480px] rounded-2xl flex flex-col overflow-hidden"
         style="background: var(--color-surface-raised); box-shadow: 0 8px 40px rgba(0,0,0,0.12), 0 4px 20px rgba(34,197,94,0.1); border: 1px solid var(--color-border-subtle); animation: card-enter 0.3s cubic-bezier(0.16,1,0.3,1)">

      <!-- Header -->
      <div class="text-white px-4 py-3 flex items-center justify-between shrink-0"
           style="background: linear-gradient(135deg, var(--color-accent), var(--color-accent-dark));">
        @if (activeThreadId()) {
          <button (click)="back()" class="mr-2 w-8 h-8 rounded-full flex items-center justify-center"
                  style="background: rgba(255,255,255,0.15); color: white; transition: all 0.2s;"
                  onmouseover="this.style.background='rgba(255,255,255,0.25)'" onmouseout="this.style.background='rgba(255,255,255,0.15)'">
            <span class="material-symbols-outlined text-[18px]">arrow_back</span>
          </button>
        }
        <span class="font-semibold text-sm flex-1">
          @if (activeThreadId()) {
            {{ activePeerName() }}<app-store-verified-badge [verified]="!!activeThreadVerified()" [size]="14" />
          } @else {
            แชท
          }
        </span>
        <button (click)="toggle()" class="w-8 h-8 rounded-full flex items-center justify-center"
                style="background: rgba(255,255,255,0.15); color: white; transition: all 0.2s;"
                onmouseover="this.style.background='rgba(255,255,255,0.25)'" onmouseout="this.style.background='rgba(255,255,255,0.15)'">
          <span class="material-symbols-outlined text-[18px]">close</span>
        </button>
      </div>

      @if (!activeThreadId()) {
        <!-- Thread List -->
        <div class="flex-1 overflow-y-auto">
          @for (thread of threads(); track thread.thread_id) {
            <button (click)="openThread(thread.thread_id)"
                    class="w-full px-4 py-3 text-left flex items-center gap-3 cursor-pointer"
                    style="border-bottom: 1px solid var(--color-border-subtle); transition: all 0.15s;"
                    onmouseover="this.style.background='var(--color-accent-lightest)'" onmouseout="this.style.background='transparent'">
              <!-- Avatar -->
              <div class="w-9 h-9 rounded-full shrink-0 flex items-center justify-center text-xs font-bold relative"
                   style="background: linear-gradient(135deg, var(--color-accent-lighter), var(--color-accent-light)); color: var(--color-accent-dark); overflow: visible;">
                @if (thread.peer_avatar_url) {
                  <img [src]="avatarSrc(thread.peer_avatar_url)" alt="" class="w-full h-full object-cover rounded-full absolute inset-0">
                } @else {
                  {{ peerName(thread)[0]?.toUpperCase() ?? '?' }}
                }
                <span class="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 z-10"
                      style="background: var(--color-accent); border-color: var(--color-surface-raised);"></span>
              </div>
              <div class="flex-1 min-w-0">
                <div class="flex items-center justify-between gap-2">
                  <p class="text-sm font-semibold truncate" style="color: var(--color-accent-darkest);">{{ peerName(thread) }}<app-store-verified-badge [verified]="threadVerified(thread)" [size]="13" /></p>
                  @if (thread.last_message_at) {
                    <span class="text-[10px] shrink-0" style="color: var(--color-neutral);">{{ thread.last_message_at | date:'HH:mm' }}</span>
                  }
                </div>
                @if (thread.last_message) {
                  <p class="text-xs truncate mt-0.5" style="color: var(--color-neutral);">{{ thread.last_message }}</p>
                } @else {
                  <p class="text-xs italic truncate mt-0.5" style="color: var(--color-neutral);">ยังไม่มีข้อความ</p>
                }
              </div>
              @if (thread.unread_count > 0) {
                <span class="shrink-0 min-w-5 h-5 px-1.5 rounded-full text-white text-[10px] font-bold flex items-center justify-center"
                      style="background: var(--color-danger);">
                  {{ thread.unread_count }}
                </span>
              }
            </button>
          } @empty {
            <div class="p-8 text-center text-sm text-text-secondary">
              <span class="material-symbols-outlined text-3xl mb-2 block" style="color: var(--color-accent-light);">forum</span>
              ยังไม่มีการสนทนา
            </div>
          }
        </div>
      } @else {
        <!-- Messages -->
        <div class="flex-1 overflow-y-auto px-4 py-3 space-y-3" #fcMsgContainer
             style="background: var(--color-surface-raised);">
          @for (msg of messages(); track msg.id) {
            <div [class]="msg.sender_type.toLowerCase() === myRole() ? 'flex justify-end' : 'flex justify-start'">
              <div class="max-w-[80%]">
                <div class="text-[10px] mb-0.5 px-1"
                     [class.text-right]="msg.sender_type.toLowerCase() === myRole()"
                     style="color: var(--color-neutral);">
                  {{ msg.created_at | date:'HH:mm' }}
                </div>
                @if (msg.sender_type.toLowerCase() === myRole()) {
                  <div class="rounded-2xl rounded-br-md px-3 py-2 text-sm text-white"
                       style="background: linear-gradient(135deg, var(--color-accent), var(--color-accent-dark)); box-shadow: 0 2px 8px rgba(34,197,94,0.25);">
                    {{ msg.message }}
                  </div>
                } @else {
                  <div class="rounded-2xl rounded-bl-md px-3 py-2 text-sm"
                       style="background: var(--color-surface-overlay); color: var(--color-text-primary); border: 1px solid var(--color-border-subtle);">
                    {{ msg.message }}
                  </div>
                }
                <!-- Read receipt -->
                @if (isLastReadByPeer(msg.id)) {
                  <div class="flex items-center gap-1 justify-end mt-0.5">
                    <span class="text-[9px]" style="color: var(--color-neutral);">อ่านแล้ว</span>
                    <app-user-avatar
                      [name]="peerReadInfo().display_name"
                      [avatarUrl]="peerReadInfo().avatar_url ? avatarSrc(peerReadInfo().avatar_url) : null"
                      [size]="14"
                      variant="accent-light" />
                  </div>
                }
              </div>
            </div>
          } @empty {
            <div class="text-center mt-8">
              <span class="material-symbols-outlined text-3xl mb-1 block" style="color: var(--color-accent-light);">waving_hand</span>
              <p class="text-xs" style="color: var(--color-accent);">ส่งข้อความแรกเลย!</p>
            </div>
          }

          <!-- Typing indicator -->
          @if (peerIsTyping()) {
            <div class="flex justify-start">
              <div class="rounded-2xl rounded-bl-md px-3 py-2 flex items-center gap-1"
                   style="background: var(--color-surface-overlay); border: 1px solid var(--color-border-subtle);">
                <span class="text-[10px]" style="color: var(--color-text-secondary);">{{ peerTypingName() }}</span>
                <span class="flex gap-0.5">
                  <span class="w-1 h-1 rounded-full animate-bounce" style="background: var(--color-accent); animation-delay: 0ms;"></span>
                  <span class="w-1 h-1 rounded-full animate-bounce" style="background: var(--color-accent); animation-delay: 150ms;"></span>
                  <span class="w-1 h-1 rounded-full animate-bounce" style="background: var(--color-accent); animation-delay: 300ms;"></span>
                </span>
              </div>
            </div>
          }
        </div>

        <!-- Input -->
        <div class="px-3 py-2.5 flex items-center gap-2 shrink-0"
             style="background: var(--color-surface-raised); border-top: 1px solid var(--color-border-subtle);">
          <input [value]="newMessage()" (input)="onNewMessage($any($event.target).value)"
                 (keyup.enter)="send()"
                 class="flex-1 px-4 py-2.5 rounded-full text-sm outline-none"
                 style="background: var(--color-surface-raised); box-shadow: var(--shadow-sm); border: 1px solid var(--color-border-subtle);"
                 placeholder="พิมพ์ข้อความ...">
          <button (click)="send()"
                  class="w-10 h-10 rounded-full flex items-center justify-center text-white shrink-0 cursor-pointer"
                  style="background: linear-gradient(135deg, var(--color-accent), var(--color-accent-dark)); box-shadow: 0 2px 8px rgba(34,197,94,0.3); transition: all 0.2s;">
            <span class="material-symbols-outlined text-lg">send</span>
          </button>
        </div>
      }

    </div>
  }

  <!-- FAB Button -->
  <div class="relative overflow-visible" style="z-index: 51;">
    @if (unreadTotal() > 0) {
      <span class="absolute -top-3 -right-3 min-w-5 h-5 px-1 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center pointer-events-none"
            style="z-index: 52; animation: badge-pulse 2s ease-in-out infinite">
        {{ unreadTotal() }}
      </span>
    }
    <button (click)="toggle()"
            class="w-14 h-14 hover:scale-110 active:scale-95 text-white rounded-full flex items-center justify-center"
            style="background: linear-gradient(135deg, var(--color-accent), var(--color-accent-dark)); box-shadow: 0 4px 20px rgba(34,197,94,0.4); transition: all 0.25s cubic-bezier(0.4,0,0.2,1);">
      <span class="material-symbols-outlined text-[28px]">chat</span>
    </button>
  </div>

</div>
